// src/components/ProtectedRoute.jsx
import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div
        style={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: 14,
          color: "#6b7280",
        }}
      >
        인증 확인중...
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // 비밀번호를 변경하지 않은 경우 비밀번호 변경 페이지로 리다이렉트
  // 단, 이미 비밀번호 변경 페이지에 있으면 리다이렉트하지 않음
  if (user.password_changed === false && location.pathname !== "/change-password") {
    return <Navigate to="/change-password" replace />;
  }

  return children;
}

export default ProtectedRoute;